import React, { useState, useEffect } from 'react';
import Icon from '../../../components/icon/icon';
import { X } from '@phosphor-icons/react';
import Input from '../../../components/input/input';
import Dropdown from '../../../components/dropdown/dropdown';
import Modal from '../../../components/modal/modal';
import './style';
import { Button, notify } from '../../../components';
import { updateListing } from '../api';
import { analyticEventLogger, convertCustomDateFormatToISO } from '../../../utils/commonUtils';
import { format } from 'date-fns';
import { TICKET_UPDATE_EVENT_CLICK } from '../../../constants/eventLogger';

const EditModal = ({ ticket, onClose, onDelete, onUpdate }) => {
  const [price, setPrice] = useState(ticket.ticketPrice);
  const [selectedValue, setSelectedValue] = useState(ticket.tickets?.toString());
  const [priceError, setPriceError] = useState('');

  const formattedTime = ticket?.event?.payload?.start_date ? format(convertCustomDateFormatToISO(ticket?.event?.payload?.start_date), 'EEE, dd MMM yyyy, h:mm a') : null;

  const options = Array(ticket?.maxQuantity).fill(1).map((n, idx) => ({
    id: (n + idx).toString(),
    label: (n + idx).toString(),
  }));

  useEffect(() => {
    setPrice(ticket.ticketPrice);
    setSelectedValue(ticket.tickets?.toString());
  }, [ticket]);

  const handleSelect = (value) => {
    const count = Number(value);
    const initialPricePerTicket = ticket.maxPrice / ticket.maxQuantity;
    const newTotalPrice = count * initialPricePerTicket;
    setSelectedValue(count?.toString());
  };

  const handlePriceChange = (e) => {
    const value =  Math.round(Number(e.target.value));
    const initialPricePerTicket = ticket.maxPrice / ticket.maxQuantity;
    const currentPricePerTicket = value;

    if (currentPricePerTicket > initialPricePerTicket) {
      setPriceError('Please enter a price less than or equal to what you paid per ticket.');
    } else if (value <= 0) {
      setPriceError('Price must be greater than zero.');
    } else {
      setPriceError('');
    }
    setPrice( Math.round(value));
  };

  const handleUpdateClick = () => {
    if (priceError === '') {
      analyticEventLogger(TICKET_UPDATE_EVENT_CLICK, {});
      updateListing(ticket._id, price, Number(selectedValue), (updatedTicketData) => {
        onUpdate(updatedTicketData);
        onClose();
        notify('success', 'Listing updated', {
          position: 'bottom-center',
          duration: 2000,
        });
      }, () => {
        notify('error', 'Failed to update the listing', {
          position: 'bottom-center',
          duration: 2000,
        });
      });
    }
  };

  return (
    <div>
      <Modal className='edit-modal items-center'>
        <div className='flex flex-col md:px-8 md:pt-8 md:py-7 p-6 pb-5 md:justify-between md:gap-1 gap-4 h-full'>
          <div className='flex flex-col gap-6'>
            <div className='flex justify-between w-full items-center'>
              <div className='flex heading-24'>Edit listing</div>
              <div>
                <Icon type='circle'
                  onClick={onClose}
                  className='flex'>
                  <X size='24' />
                </Icon>
              </div>
            </div>
            <div className='flex md:flex-row flex-col gap-2'>
              <img
                src={ticket.event?.payload?.image}
                alt={ticket.event?.payload?.name}
                className='md:w-[126px] md:h-[72px] w-[290px] h-[160px] object-cover rounded-lg'
              />
              <div className='flex flex-col gap-1 ml-2'>
                <div className='heading-16'>{ticket.event?.payload?.name}</div>
                <div className='text-16'>{formattedTime}</div>
                <div className='text-16'>{ticket.event?.payload?.venue}</div>
              </div>
            </div>
            <Input
              label='Price per ticket'
              contentLeft='₹'
              value={ Math.round(price)}
              onChange={handlePriceChange}
              helpText={priceError}
              validationStatus={priceError ? 'error' : 'default'}
              className='w-full'
            />
            <Dropdown
              label='How many tickets do you want to sell?'
              options={options}
              value={selectedValue}
              onChange={handleSelect}
              className='w-full mb-2 items-center'
              placeholder={selectedValue}
              width='100%'
            />
          </div>
          <div className='flex flex-col w-full items-center justify-center gap-5'>
            <Button type='primary-black'
              onClick={handleUpdateClick}
              disabled={!!priceError}
              className='w-full'
            >
              Update
            </Button>
            <Button type='tertiary-text-underlined'
              onClick={() => onDelete(ticket)}
              className='w-full'
            >
              Delete listing
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditModal;
